import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  private tooltipEl!: HTMLElement;
  private renderer: Renderer2;
  private hideTimer: any;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.tooltipEl = this.renderer.createElement('div');
    // Tooltip styling
    this.renderer.setStyle(this.tooltipEl, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipEl, 'background', '#4a4a4a');
    this.renderer.setStyle(this.tooltipEl, 'color', '#fff');
    this.renderer.setStyle(this.tooltipEl, 'padding', '2px 6px');
    this.renderer.setStyle(this.tooltipEl, 'border-radius', '4px');
    this.renderer.setStyle(this.tooltipEl, 'font-size', '12px');
    this.renderer.setStyle(this.tooltipEl, 'white-space', 'nowrap');
    this.renderer.setStyle(this.tooltipEl, 'box-shadow', '0 1px 4px rgba(0,0,0,0.2)');
    this.renderer.setStyle(this.tooltipEl, 'pointer-events', 'none');
    this.renderer.setStyle(this.tooltipEl, 'z-index', '1000');
    this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    this.renderer.setStyle(this.tooltipEl, 'transition', 'opacity 0.2s, transform 0.2s');

    document.body.appendChild(this.tooltipEl);
  }

  showTooltip(
    content: string,
    hostEl: HTMLElement,
    position: 'top' | 'bottom' | 'auto' = 'auto'
  ) {
    clearTimeout(this.hideTimer);
    this.tooltipEl.textContent = content;

    requestAnimationFrame(() => {
      const rect = hostEl.getBoundingClientRect();
      const tooltipRect = this.tooltipEl.getBoundingClientRect();

      let top: number;
      const canShowTop = rect.top >= tooltipRect.height + 6;

      if (position === 'top' || (position === 'auto' && canShowTop)) {
        top = rect.top - tooltipRect.height - 6 + window.scrollY;
        this.renderer.setStyle(this.tooltipEl, 'transform', 'translateY(4px)');
      } else {
        top = rect.bottom + 6 + window.scrollY;
        this.renderer.setStyle(this.tooltipEl, 'transform', 'translateY(-4px)');
      }

      let left =
        rect.left + (rect.width - tooltipRect.width) / 2 + window.scrollX;

      const maxLeft =
        window.scrollX + window.innerWidth - tooltipRect.width - 4;

      if (left > maxLeft) left = maxLeft;
      if (left < window.scrollX + 4) left = window.scrollX + 4;

      this.renderer.setStyle(this.tooltipEl, 'top', `${top}px`);
      this.renderer.setStyle(this.tooltipEl, 'left', `${left}px`);

      this.renderer.setStyle(this.tooltipEl, 'opacity', '1');
      this.renderer.setStyle(this.tooltipEl, 'transform', 'translateY(0)');
    });
  }

  hideTooltip(delay = 0) {
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      this.renderer.setStyle(this.tooltipEl, 'opacity', '0');
    }, delay);
  }
}
